module.exports = __webpack_public_path__ + "static/media/Mitigation.e97ad5d5.svg";